import styled from 'styled-components'

export const ProjectSummary = styled.div`
  margin-bottom: 48px;
`
